import React, { useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import styled from 'styled-components'

import FeatureTour from 'pages/FeatureTour'
import Footer from 'components/Footer'
import ImpersonationBanner from 'components/ImpersonationBanner'
import PremiumWidget from 'components/PremiumWidget'
import ProductionBanner from 'components/ProductionBanner'
import ServerErrorBanner from 'components/ServerErrorBanner'
import SideNavbar from 'components/SideNavbar'
import SiteMessageBanners from 'pages/SiteMessageBanners'
import Toast from 'components/Toast'
import UpgradeModal from 'pages/shared/UpgradeModal'

import { useFeaturesContext } from 'hooks/FeaturesContext'
import { usePremiumFeaturesContext } from 'hooks/PremiumFeaturesContext'
import useScreenSize from 'hooks/useScreenSize'
import { useSessionContext } from 'hooks/SessionContext'
import { useStoreContext } from 'hooks/StoreContext'
import { DialogProvider } from 'hooks/useDialog'

import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'
import fetchCognitoToken from 'helpers/aws'

const AppLayout = () => {
  const { session, isSessionLoaded, isUpgraded } = useSessionContext()
  const { isEnabledFeaturesLoaded } = useFeaturesContext()
  const { arePremiumFeaturesLoaded } = usePremiumFeaturesContext()
  const { toast, setToast } = useStoreContext()

  const [showUpgradeModal, setShowUpgradeModal] = useState(isUpgraded)

  const screenSize = useScreenSize()

  useEffect(() => {
    if (!isSessionLoaded) { return }

    setShowUpgradeModal(isUpgraded)
  }, [isUpgraded, isSessionLoaded])

  useEffect(() => {
    fetchCognitoToken()
  }, [])

  if (!isEnabledFeaturesLoaded || !isSessionLoaded || !arePremiumFeaturesLoaded) { return null }

  return (
    <DialogProvider>
      <S.Layout>
        {showUpgradeModal && !session.isDealerAdmin && (<UpgradeModal closeCallback={() => setShowUpgradeModal(false)} />)}
        <SideNavbar />

        <S.BannersAndMain>
          <ProductionBanner />
          <ServerErrorBanner />
          <SiteMessageBanners />
          <FeatureTour />
          <ImpersonationBanner />
          {screenSize !== 'small' && <PremiumWidget />}

          <S.MainContent>
            <Toast
              title={toast?.title}
              type={toast?.type}
              message={toast?.message}
              onClose={() => { setToast(null) }}
              open={toast?.open}
            />

            <Outlet />
          </S.MainContent>

          <Footer />
        </S.BannersAndMain>
      </S.Layout>
    </DialogProvider>
  )
}

export default AppLayout

const S = {
  Layout: styled.div`
      display: flex;
      height: 100%;
    `,
  BannersAndMain: styled.div`
      display: flex;
      flex: 1 1 auto;
      width: 100%;
      flex-direction: column;
      background-color: ${color('background')};
  
      @media ${screenSize.small} {
        margin: 40px 0px 0px 0px; /* Appbar height */
      }
    `,
  MainContent: styled.div`
      flex: 1;
      width: 100%;
    `
}
